<template>
  <main v-bind="dKey('pageid', pageName, postId)">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div v-bind="dKey('bgTitle')" class="grey-title-block resp-number">{{getInfo('bgTitle')}}</div>
      </div>
    </section>
    <section class="news-section">
        <div class="container">
          <div class="row title-wrapper">
            <div class="col-sm-12 wow fadeInLeft pb-5" data-wow-duration="2s" data-wow-delay=".5s">
              <span v-bind="dKey('subtitle')" class="section-title">{{info.subtitle}}</span>
              <h3 v-bind="dKey('title')">{{info.title}}</h3>
            </div>
            <div class="col-sm-12 about-first-content post-content">
              <div class="img-thumbnail float-right content-image">
                <img id="post-main-image" v-bind:src="image" class="" alt="">
                <div v-if="$root.isAdmin()" class="img-buttons mt-1">
                  <div v-for="error in errors" class="alert alert-danger mt-1 mb-1 ml-0 mr-0 show fade" role="alert">{{error}}</div>
                  <button @click="uploadImage" class="btn btn-primary">Select Image</button>
                  <input id="upload-image" type="file" name="image" value="" class="hidden" />
                  <span v-if="$root.isAdmin()" v-bind="dKey('image')" class="hidden">{{image}}</span>
                </div>
              </div>
              <div data-type="editor" v-bind="dKey('content')" v-html="info.content"></div>
            </div>
            <div v-if="$root.isAdmin()" class="col-sm-12 inputs-wrapper">
              <div>
                <label>Post URl</label>
                <span v-model="info.url" v-bind="dKey('url')" class="hidden">{{info.url}}</span>
                <input type="text" name="url" v-model="info.url" placeholder="Post URL" autocomplete="off" />
              </div>
            </div>
          </div>
        </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'News',

  data() {
    return {
      url: '',
      info: {},
      image: null,
      postId: 0,
      pageName: 'post',
      editorLoaded: false,
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.getPost()
  },

  watch:{
    $route () {
      this.getPost()
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getInfo(key) {
      if (this.info.json && this.info.json[key])
        return this.info.json[key]
      return 'text'
    },

    uploadImage() {
      let $input = $('#upload-image')
      let accessToken = this.$root.accessToken
      let self = this

      $input.off('change').on('change', function(){
        let data = new FormData

        data.append('img', $input.prop('files')[0])

        HTTP.post('uploaders/images/upload?access_token=' + accessToken, data)
        .then(response => {
          self.errors = []

          if (response.data.result.files && response.data.result.files.img) {
            self.image = null
            self.image = '/static-assets/images/' + response.data.result.files.img[0].name
          }
        }).catch(e => {
          self.errors = []
          self.errors.push(e.response.data.error.message.indexOf('maxFileSize') != -1 ? 'Объем изображение должен быть не более 2Мб.' : e.response.data.error.message)
        })
      })

      $input.trigger('click')
    },

    summerNote() {
      function initSummerNote() {
        $('[data-type="editor"]').summernote('reset')
        $('[data-type="editor"]').summernote('destroy')

        $('[data-type="editor"]').summernote({
          airMode: true,
          popover: {
            air: [
              ['style', ['style']],
              ['font', ['fontname', 'fontsize', 'forecolor', 'backcolor', 'color', 'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
              ['para', ['ul', 'ol', 'paragraph', 'height']],
              ['insert', ['picture', 'link', 'video', 'table']]

            ], image: [
              ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
              ['float', ['floatLeft', 'floatRight', 'floatNone']],
              ['remove', ['removeMedia']]
            ], link: [
              ['link', ['linkDialogShow', 'unlink']]
            ],
          },

          events: {
            'insertParagraph': function (evt) {
              if (evt.which === 13 || evt.keyCode === 13)
                evt.shiftKey = true;
            }
          }
        })
      }

      if (this.$root.isAdmin()) {
        if (!this.editorLoaded) {
          this.$root.styleLoader('/static-assets/js/summernote/summernote-bs4.css', () => {
            this.$root.scriptLoader('/static-assets/js/summernote/summernote-bs4.min.js', () => {
              initSummerNote()
            })
          })
        } else {
          initSummerNote()
        }
      }
    },

    getPost() {
      this.url = this.$route.params.url || false

      HTTP.get('posts?filter=' + encodeURIComponent(JSON.stringify({
        where: {
          and: [
            {type: 'news'},
            {url: this.url},
            {language_id: this.$root.language_id}
          ]
        }
      }))).then(response => {
        if (response.data.length) {
          this.info = response.data[0]
          this.postId = this.info.id
          this.image = this.info.image
          this.info.json = this.info.json.length ? JSON.parse(this.info.json) : {}

          document.querySelector('title').text = this.info.meta_title.length
            ? this.info.meta_title
            : 'Antwerk'

          document.querySelector('meta[name="description"]').text = this.info.meta_description.length
            ? this.info.meta_description
            : ''

          this.$root.$emit('post_update', {
            status: this.info.status,
            url: this.info.url
          })

          this.summerNote()
        }
      }).catch(e => {
        this.errors.push(e)
      })
    }
  }
}

</script>

<style scoped>

.content-image {
  margin-left: 20px;
  margin-bottom: 20px;
  max-width: 50%;
}

.content-image img {
  max-width: 100%;
}

.inputs-wrapper input {
  background: transparent;
}

.img-buttons {
  position: relative;
  z-index: 1000;
}

.post-content {
  width: 100%;
}

</style>
